<template>
  <div v-if="isOpen" class="modal fade show" aria-labelledby="addNewCardTitle"
       style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">{{ modalTitle }}</h1>
              <button
                  @click="toggleModal"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <hr class="mt-0">

        <div class="pb-2">
          <!-- form -->
          <vForm @submit="submit" :validation-schema="schema">
            <div class="row gy-2 px-2">
              <div class="col-md-6">
                  <label class="form-label">Category</label>
                  <v-select
                      v-model="formData.investigation_type"
                      label="name"
                      :options="typeArr"
                      :reduce="name => name.id"
                  />
              </div>

              <div class="col-md-6 discharge-cert">
                <div class="form-check">
                  <input v-model="formData.has_discharge_certificate" class="form-check-input" id="remember-me" type="checkbox" tabindex="3"/>
                  <label class="form-check-label" for="remember-me"> Discharge Certificate?</label>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Investigation Head</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="name"
                      v-model="formData.name"
                      class="form-control add-credit-card-mask"
                      placeholder="Investigation Head"
                  />
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-md-6 mt-0">
                  <div class="col-12">
                    <label class="form-label"> Investigation Report Types </label>
                    <v-select
                      v-model="formData.investigation_report_type"
                      label="name"
                      :options="investigationReportTypes"
                      :reduce="name => name.id"
                    />
                  </div>

                  <div class="col-md-6 col-12 discharge-cert mt-2" v-if="formData.investigation_report_type == 'general_table'">
                    <div class="form-check">
                      <input v-model="formData.is_result_dropdown" class="form-check-input" id="is_result_dropdown" type="checkbox" tabindex="3"/>
                      <label class="form-check-label" for="is_result_dropdown"> Is Result Dropdown?</label>
                    </div>
                  </div>

                <div class="col-12 mt-2" v-if="formData.investigation_report_type == 'general_text'">
                    <label class="form-check-label" for="note_master_type">Note Master Type</label>
                    <v-select
                        placeholder="Select type"
                        :options="noteTypes" v-model="formData.note_master_type"
                        :reduce="name => name.value"
                        label="name"
                    />
                </div>

                  <div class="col-12 mt-2">
                    <div class="d-flex justify-content-between">
                      <label class="form-label">Select Service Name</label>
                      <button 
                        type="button"
                        @click="openProductAddModal" 
                        class="btn btn-primary btn-sm">
                          Add
                      </button>
                    </div>
                    <AsyncSelect
                      placeholder="Select Service Name"
                      v-model="formData.product_id"
                      :api-service="fetchProductList"
                      :reduce="name => name.id"
                      :format-label="option => option.text"
                      :additional-query="{product_type: 'services'}"
                      :additional-option="isProductAdded ? [newlyAddedProduct] : additionalOptions"
                      label="text"
                    />
                  </div>
              </div>

              <div v-if="showParent" class="col-md-6">
                <label class="form-label">Parent Group</label>
                <v-select
                    v-model="formData.head_group_id"
                    label="name"
                    :options="group"
                    :reduce="name => name.id"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Unit</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="unit"
                      v-model="formData.unit"
                      class="form-control add-credit-card-mask"
                      placeholder="Unit"
                  />
                  <ErrorMessage name="unit" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Investigation Report Name</label>
                <v-select
                    v-model="formData.investigation_head"
                    label="name"
                    :options="reports"
                    placeholder="Investigation Report Name"
                    :reduce="name => name.name_key"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Reference Value</label>
                <div class="input-group">
                  <textarea 
                    v-model="formData.reference_value"
                    name="reference" rows="2"
                    placeholder="Reference Value"
                    class="form-control add-credit-card-mask"
                  >
                  </textarea>
                </div>
              </div>

              <div v-if="showParent" class="col-md-6">
                <label class="form-label">Specimen</label>
                
                <AsyncSelect
                  placeholder="Select Specimen"
                  v-model="formData.sample"
                  :api-service="fetchNoteMasterList"
                  :additional-query="{note_type: 'specimen'}"
                  :additional-option="additionalSampleOption ? [additionalSampleOption] : []"
                  label="name"
                  :reduce="name => name.name_key"
                />
              </div>

              <div v-if="showParent" class="col-md-6">
                <label class="form-label">Test Method</label>
                <v-select
                    v-model="formData.test_method"
                    label="name"
                    :options="testMethodArr"
                    placeholder="Select test method"
                    :reduce="name => name.id"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Code</label>
                <div class="input-group">
                  <vField
                      type="text"
                      name="code"
                      v-model="formData.code"
                      class="form-control add-credit-card-mask"
                      placeholder="Code"
                  />
                  <ErrorMessage name="code" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Default Value</label>
                <div class="input-group">
                    <textarea 
                      v-model="formData.default_result"
                      name="reference" rows="2"
                      placeholder="Default value"
                      class="form-control add-credit-card-mask"
                    >
                    </textarea>
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="Full">Short Description</label>
                <textarea 
                    v-model="formData.short_description"
                    name="reference" rows="2"
                    placeholder="Short description"
                    class="form-control add-credit-card-mask"
                  >
                  </textarea>
              </div>

              <div class="col-12">
                <label class="form-label" for="Full">Full Description</label>
                <textarea 
                    v-model="formData.full_description"
                    name="reference" rows="2"
                    placeholder="Full description"
                    class="form-control add-credit-card-mask"
                  >
                  </textarea>
              </div>

              <div class="col-md-6">
              <label class="form-label"> Machine Type </label>
                <v-select
                    placeholder="Select Machine Type"
                    v-model="formData.machine_type"
                    label="name"
                    :options="machineTypes"
                    :reduce="name => name.value"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label">Machine Data Key</label>

                <AsyncSelect
                    placeholder="Select Machine Data Key"
                    v-model="formData.machine_key_note_master_id"
                    :api-service="fetchNoteMasterList"
                    :reduce="name => name.id"
                    :format-label="option => option.name"
                    :additional-query="{note_type: 'machine_data_key'}"
                    :additional-option="machineKeyAdditionalOptions"
                    label="name"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label" for="chartName">Decimal Count</label>
                <div class="input-group">
                  <vField
                      type="number"
                      name="decimal_count"
                      v-model="formData.decimal_count"
                      class="form-control add-credit-card-mask"
                      placeholder="Decimal Count"
                  />
                  <ErrorMessage name="code" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12 col-md-6 px-2">
                <label class="form-label" for="modalEditUserStatus">Status</label>
                <v-select
                    placeholder="Select Status"
                    v-model="formData.status"
                    :options="statusList"
                    label="name"
                    :reduce="item => item.value"
                />
              </div>
            </div>

            <div class="col-12 text-center">
              <hr class="mt-2">
              <button :disabled="loading" type="submit"
                      class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button @click.prevent="toggleModal" class="btn btn-outline-secondary mt-1 waves-effect">
                Cancel
              </button>
            </div>
          </vForm>
        </div>
      </div>
    </div>
  </div>
  <ProductAddModal
    :accountHeadSlags="accountHeadSlags"
    :accountHeads="accountHeads"
    :units="units"
    :group="productGroup"
    :formData="productAdd"
    :inventoryMethods="inventoryMethods"
    :specifications="specifications"
    :isShortAdd="true"
    @onClickSubmitProduct="handleProductSubmit"
    @onCloseModal="onCloseModal"
    ref="productAdd"
  />
</template>

<script>
import { inject } from 'vue'
import objToArray from '@/services/utils/object-to-array'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handlePurchase from '@/services/modules/purchase';
import ProductAddModal from '@/components/molecule/company/inventory/product-service/ProductAddModal';
import handleInventory from '@/services/modules/inventory'
import handleHospital from '@/services/modules/hospital';

const {fetchProductList} = handlePurchase()

export default {
  name: 'InvestigationAddModal',

  data: () => ({
    isOpen : false,
    loading: false,
    schema : {
      name: 'required|max:100',
    },
    accountHeadSlags: {},
    accountHeads: [],
    noteTypes: [],
    selectedSpecifications: [],
    units: [],
    productGroup: [],
    productAdd: {
      company_id: '',
      product_head_id: null,
      contact_profile_id: null,
      specifications: {},
      name: '',
      unit_id: null,
      purchase_price: '',
      purchase_account_head_id: null,
      sales_price: '',
      sales_account_head_id: null,
      cost_of_sales: '',
      cost_of_sales_account_head_id: null,
      inventory_account_head_id: null,
      default_purchase_unit_id: null,
      default_sales_unit_id: null,
      default_shipping_unit_id: null,
      alternative_unit_ids: [],
      sku: '',
      short_description: '',
      full_description: '',
      image: null,
      status: 'active',
      decimal_count: '',
      additional_images: [],
      vat_rate: '',
      inventory_method: 'fifo',
    },
    inventoryMethods: [],
    isProductAdded: false,
    newlyAddedProduct: null,
    investigationReportTypes: [],
    machineTypes: [],
    statusList: [],
    additionalSampleOption: null,
    specifications: {}
  }),

  components: {
    AsyncSelect,
    ProductAddModal
  },

  computed: {
    additionalOptions(){
        if (!this.product) return [];

        return [
            {
                id: this.product.id,
                text: this.product.name,
            }
        ]
    },

    machineKeyAdditionalOptions(){
      if (!this.machineDataNoteMaster) return [];

      return [
        {
          id: this.machineDataNoteMaster.id,
          name: this.machineDataNoteMaster.name,
        }
      ]
    },
    statusArr() {
      return Object.keys(this.status)
    },
    typeArr() {
      return objToArray(this.type)
    },
    testMethodArr() {
      return objToArray(this.testMethods)
    },
    companyId() {
      return this.$route.params.companyId
    },
    sampleType() {
      return this.formData.sample;
    }
  },

  methods: {
    fetchProductList,
    submit() {
      this.$emit(this.submitEvent)
    },
    toggleModal() {
      this.isProductAdded = false;
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        this.$emit("onCloseLocationModal")
        return
      }
      this.openModal();
    },

    openProductAddModal () {
      this.$refs.productAdd.toggleModal()
    },

    onCloseModal() {
      this.$refs.productAdd.toggleModal();
    },

    async openModal () {
      await this.$nextTick();
      const query = `?company_id=${this.companyId}`;
      const slags = ['purchase_accounts', 'sales_accounts', 'cost_of_sales'];
      const slagQuery = `?company_id=${this.companyId}` + slags.map(s => `&slags[]=${s}`).join('');
      const noteTypeQuery = `?company_id=${this.companyId}`

      let p1 = this.fetchAccountHeadsBySlags(slagQuery);
      let p2 = this.fetchAccountHeads(this.companyId);
      let p3 = this.fetchUnit(this.companyId);
      let p4 = this.fetchGroup(this.companyId, 'services');
      let p5 = this.fetchHome();
      let p6 = this.fetchSpecification(this.companyId);

      Promise.all([
          p1.then(res => {
            if(res.status) {
              this.accountHeadSlags = res.data;
              this.setDefaultSlagHead(res.data);
            } 
          }),
          p2.then(res => {
             if(res.status) {
                this.accountHeads = res.data
                this.setDefaultHead(res.data)
             }
          }),
          p3.then(res => {
              this.units = res.data
          }),
          p4.then(res => {
             if(res.data) this.productGroup = res.data
          }),
          p5.then(res => {
             if(res.data) this.prepareInventoryMethods(res.data);
          }),
          p6.then(res => {
             if(res.data) this.specifications = res.data;
          }),
          this.fetchNoteTypes(noteTypeQuery)
              .then(res => {
                if(res.data) this.noteTypes = res.data;
              }),
          this.sampleType
            ? this.fetchNoteByKey(query, 'specimen', this.formData.sample).then(res => {
                if (res.status) this.additionalSampleOption = res.data;
              }) 
            : Promise.resolve(),
      ])
      .then(res => {
          this.loading = false
      })
      .catch(error => {
          this.loading = false
      });
    },

    prepareInventoryMethods (homeContent) {
      this.inventoryMethods = [];
      this.investigationReportTypes = [];
      this.machineTypes = [];
      this.statusList = [];
      Object.keys(homeContent.inventory_methods).forEach((val)=>{
        this.inventoryMethods.push({
          id : val,
          name : homeContent.inventory_methods[val],
        })
      });

      Object.keys(homeContent.investigation_report_types || {}).forEach((key) => {
        this.investigationReportTypes.push({
          id: key,
          name: homeContent.investigation_report_types[key],
        });
      });

      if (homeContent.machine_type){
         this.machineTypes = homeContent.machine_type;
      }

      if (homeContent.status){
        const allowedStatuses = ['active', 'inactive'];

        this.statusList = Object.keys(homeContent.status)
            .filter(key => allowedStatuses.includes(key))
            .map(key => ({
              value: key,
              name: homeContent.status[key]
            }));
      }
    },

    setDefaultSlagHead(data) {
      let product = this.productAdd
      if(!data) return;

      //set first account payable as default
      if (data.purchase_accounts.length) {
          product.purchase_account_head_id = data.purchase_accounts[0].id;
      }
        
      // set first sales_accounts head
      if (data.sales_accounts.length) {
          product.sales_account_head_id = data.sales_accounts[0].id;
      }
        
      // set first cost_of_sales head
      if (data.cost_of_sales.length) {
          product.cost_of_sales_account_head_id = data.cost_of_sales[0].id;
      }
    },
  
    setDefaultHead(data) {
      let product = this.productAdd
      if(!data.length) return;

      //set first inventory head as default
      let firstInventoryAccount = data.find(i => i.account_slug == 'inventory_assets')
      if(firstInventoryAccount) product.inventory_account_head_id = firstInventoryAccount.id
    },

    async handleProductSubmit() {
      try {
        if(this.productAdd.inventory_method == null) delete this.productAdd.inventory_method
        this.productAdd.company_id = this.companyId;
        let fd = new FormData();
        Object.keys(this.productAdd).forEach(key => {
            if(
                ! ["alternative_unit_ids"].includes(key) &&
                this.productAdd[key] !== null
            ) {
                fd.append(key, this.productAdd[key])
            }
        })
        const alternativeUnitIds = this.productAdd.alternative_unit_ids.map(unitId => {
            return {
                unit_id: unitId
            }
        });

        fd.append('specifications', JSON.stringify(this.productAdd.specifications));
        fd.append('alternative_unit_ids', JSON.stringify(alternativeUnitIds));

        let res = await this.storeProduct(fd)
        if(!res.status) {
            this.showError(res.message);
            return;
        }
        this.showSuccess(res.message);
        this.formData.product_id = res.data.id;
        this.isProductAdded = true;
        this.newlyAddedProduct = {
          id: res.data.id,
          text: res.data.text
        }
        this.$refs.productAdd.toggleModal();
        this.resetForm();
      } catch (err) {
        console.log('Something went wrong')
      }
    },

    resetForm() {
      let product = this.product
      product.name = ''
      product.unit_id = null
      product.purchase_price = ''
      product.sales_price = ''
      product.cost_of_sales = ''
      product.sku = ''
      product.short_description = ''
      product.full_description = ''
      product.vat_rate = ''
      product.alternative_unit_ids = []
      product.inventory_method = 'fifo'
    }
  },

  props: {
    formData   : Object,
    product: Object | null,
    machineDataNoteMaster: Object | null,
    showParent : {
      type   : Boolean,
      default: false
    },
    type       : Object,
    group      : Array,
    sampleTypes : {
      type: Object,
      default: {},
    },
    testMethods : {
      type: Object,
      default: {},
    },
    reports : {
      type: Array,
      default: {},
    },
    status     : Object,
    modalTitle : {
      type   : String,
      default: 'Add Investigation'
    },
    submitEvent: {
      default: 'onSubmitLocation'
    },
    isFromList: {
      type: Boolean,
      default: false
    }
  },

  emits: ['onSubmitLocation', 'onUpdateLocation', 'onCloseLocationModal'],

  setup() {
    const showError =  inject('showError');
    const showSuccess =  inject('showSuccess');

    const {
      fetchAccountHeadsBySlags,
      fetchAccountHeads,
      fetchUnit,
      fetchGroup,
      fetchHome,
      fetchSpecification,
      storeProduct
    } = handleInventory()

    const { fetchNoteMasterList, fetchNoteByKey, fetchNoteTypes } = handleHospital();

    return {
      fetchAccountHeadsBySlags,
      fetchAccountHeads,
      fetchUnit,
      fetchGroup,
      fetchHome,
      fetchSpecification,
      storeProduct,
      showError,
      showSuccess,
      fetchNoteMasterList,
      fetchNoteByKey,
      fetchNoteTypes
    }
  }
}
</script>

<style scoped>
  .discharge-cert{
    display: flex;
    align-items: center;
  }
</style>
